import React from 'react';
export const GenericSquare = ({ x = 0, y = 0, width, height, cornerRadius = 0, strokeWidth = 1, strokeColor, fill, children, notBounding = false, className, forcedCursor: cursor, }) => {
    return (React.createElement("svg", { x: x, y: y, width: width, height: height },
        React.createElement("rect", { className: className, "data-not-bounding": notBounding, width: width, height: height, rx: cornerRadius, ry: cornerRadius, stroke: strokeColor, fill: fill, strokeWidth: strokeWidth, style: { cursor } }),
        children));
};
//# sourceMappingURL=generic-square.js.map